import { render, staticRenderFns } from "./BodyguardList.vue?vue&type=template&id=5b286cc2"
import script from "./BodyguardList.vue?vue&type=script&lang=js"
export * from "./BodyguardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports